<template>
  <div>
    <section-header variants="dividing" size="md">
      <template slot="content">
        <heading level="2" size="md" qaid="allocatedBackorder.filtersHeading">{{ bp('filter') }}</heading>
      </template>
    </section-header>

    <form @submit.prevent="filterChanged">
      <div class="lg:flex flex-col ">
        <div class="md:flex">
          <div class="flex flex-col md:w-1/3">
            <form-group
              v-model="description"
              type="text"
              name="description"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('contactUs.model')"
              qaid="allocatedBackorder.descriptionFilter"
            ></form-group>
            <form-group
              v-model="orderNumber"
              type="text"
              name="orderNumber"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('orderNumber')"
              qaid="allocatedBackorder.orderNumberFilter"
            ></form-group>
          </div>
          <div class="flex flex-col md:w-1/3">
            <form-group
              v-model="customerPo"
              type="text"
              name="customerPo"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('customerPo')"
              qaid="allocatedBackorder.customerPoFilter"
            ></form-group>
            <form-group
              v-model="sku"
              type="text"
              name="sku"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('sku')"
              qaid="allocatedBackorder.skuFilter"
            ></form-group>
          </div>
          <div class="flex flex-col md:w-1/3">
            <form-group
              type="checkbox"
              :multi-items="[{value: 'hideUnallocated', checked: hideUnallocated, displayName: bp('hideUnallocated')}]"
              class="mb-0"
              :label="bp('text.orders')"
              name="hide-unallocated"
              qaid="allocatedBackorder.hideUnallocatedFilter"
              @change="handleCheckboxChange"
            ></form-group>

            <form-group
              type="checkbox"
              :multi-items="[
                {
                  value: 'hideLinesWithoutComments',
                  checked: hideLinesWithoutComments,
                  displayName: bp('hideLinesWithoutComments'),
                },
              ]"
              name="hide-lines-without-comments"
              class="md:mb-0"
              qaid="allocatedBackorder.hideLinesWithoutCommentsFilter"
              @change="handleCheckboxChange"
            ></form-group>
          </div>
        </div>

        <div class="buttons">
          <trek-button primary qaid="allocatedBackorder.applyFilters" @click="filterChanged">
            {{ bp('filter') }}
          </trek-button>
          <trek-button secondary qaid="allocatedBackorder.clearFilters" @click="clearFilters">
            {{ bp('text.clearFilters') }}
          </trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import FormGroup from '@/components/FormGroup';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'AllocatedBackorderHistoryFilters',
  components: {
    TrekButton,
    FormGroup,
    SectionHeader,
    Heading,
  },
  props: {
    redirectFilterSku: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hideUnallocated: false,
      hideLinesWithoutComments: false,
      description: '',
      orderNumber: '',
      customerPo: '',
      sku: '',
    };
  },
  mounted() {
    this.sku = this.redirectFilterSku ? this.redirectFilterSku : this.sku;
  },
  methods: {
    filterChanged() {
      this.$emit('changed', {
        hideUnallocated: this.hideUnallocated,
        hideLinesWithoutComments: this.hideLinesWithoutComments,
        description: this.description,
        orderNumber: this.orderNumber,
        customerPo: this.customerPo,
        sku: this.sku,
      });
    },
    clearFilters() {
      this.resetFilters();
      this.filterChanged();
    },
    resetFilters() {
      this.hideUnallocated = false;
      this.hideLinesWithoutComments = false;
      this.description = '';
      this.orderNumber = '';
      this.customerPo = '';
      this.sku = '';
    },
    handleCheckboxChange() {
      if (event && event.target && event.target.value === 'hideUnallocated') {
        this.hideUnallocated = event.target.checked;
      }
      if (event && event.target && event.target.value === 'hideLinesWithoutComments') {
        this.hideLinesWithoutComments = event.target.checked;
      }
    },
  },
};
</script>
